<template>
	<div class="margin-left list">
		<div class="flex margin-bottom-sm align-center topall bg-white">
			<p @click="chose(item.type)" class="flex-sub text-center pointer" :class="topindex == item.type?'active text-theme':''" v-for="(item,index) in top" :key="index">{{item.name}}</p>
			
		</div>
		<div v-if="total != 0">
			<el-row :gutter="20">
				<el-col :span="12" v-for="(item,index) in listData" :key="index">
					<CourseList :data="item" @godetail="godetail"></CourseList>
				</el-col>
			</el-row>
			<div class="pagination">
				<el-pagination
				  background
				  layout="prev, pager, next"
				  @current-change="handleCurrentChange"
				  prev-text="上一页"
				  next-text="下一页"
				  :total="total">
				</el-pagination>
			</div>
		</div>
		<div class="text-center" v-else>
			<el-empty description="暂无数据"></el-empty>
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	import CourseList from '../../list/course-list.vue';
	export default {
		components: {
			CourseList,
		},
		data() {
			return {
				top:[
					{
						name:'全部',
						type:4
					},{
						name:'待审核',
						type:0
					},{
						name:'已通过',
						type:2
					},{
						name:'已驳回',
						type:1
					}
				],//状态
				topindex:4,//选中的状态下表
				listData:[],//列表
				page:1,
				total:0,//
			};
		},
		created() {
			this.getlist()
		},
		methods: {
			//选择状态
			chose(index){
				this.topindex = index
				this.page = 1
				this.getlist()
			},
			//去详情
			godetail(e){
				let type = {
					type:'exadetail',
					typeone:'examine'
				}
				this.$emit('gettype',type)
				console.log(e);
				setTimeout(() => {
				     Bus.$emit('getdid',e.id)
				   }, 20);
			},
			handleCurrentChange: function(currentPage) {
			  this.page = currentPage;
			  this.getlist();
			},
			/* 我的课程列表
			 * */
			getlist(){
				this.ajax('get', '/api/pc/courseapply/getApplyList',{
					page:this.page,
					is_resources:this.topindex
				}, res => {
					console.log(res);
					if(res.status == 200){
						this.listData = res.data.data
						if(this.page == 1){
							this.total =  Number(res.data.lastpage) * Number(res.data.data.length)
						}
					}else{
						this.$message(res.msg);
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.list{
		width: 921px;
	}
	.topall{
		width: 921px;
		height: 69px;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2000);
		border-radius: 10px;
		p{
			height: 69px;
			line-height: 69px;
		}
	}
	/deep/ .el-pagination.is-background .btn-next,/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .el-pager li{
		background: #fff !important;
	}
	/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
		background:#09827B !important;
		color: #fff !important;
	}
	/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .btn-next{
		padding: 0 10px;
	}
	
	.pagination{
		margin: 59px 0;
	}
	.active{
		
		position: relative;
		&:after{
			position: absolute;
			bottom: 0;
			left: 50%;
			transform: translateX(-50%);
			width: 27px;
			height: 6px;
			background: #0B837C;
			border-radius: 3px;
			content: '';
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/my/course/examine.vue